import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {format} from "date-fns";

const ColumnChart = ({data}) => {
	const options = {
		chart: {
			type: "column",
			//backgroundColor: "#f4f4f4",
			borderWidth: 1,
			borderRadius: 5,
			borderColor: "#CCC",
			style: {
				fontSize: "16px",
			},
		},
		title: {
			text: "Starters & Leavers",
			//align: "left",
		},
		xAxis: {
			categories: data.map((item) => format(item.date, "MMM yy")),
			crosshair: true,
			accessibility: {
				description: "Months",
			},
		},
		yAxis: {
			min: 0,
			title: {
				text: null,
			},
			gridLineWidth: 0,
		},
		tooltip: {
			enabled: true,
		},
		plotOptions: {
			column: {
				pointPadding: 0.2,
				borderWidth: 0,
				borderRadius: 4,
			},
		},
		series: [
			{
				name: "Starters",
				data: data.map((item) => item.starters),
				color: "#0F0",
			},
			{
				name: "Leavers",
				data: data.map((item) => item.leavers),
				color: "#ea611c",
			},
		],
		credits: {
			enabled: false,
		},
		responsive: {
			rules: [
				{
					condition: {
						maxWidth: 500,
					},
					chartOptions: {
						xAxis: {
							labels: {
								formatter: function () {
									return this.value.substr(0, 3); // Shorten month names
								},
							},
						},
					},
				},
			],
		},
	};

	return (
		<div>
			<HighchartsReact
				highcharts={Highcharts}
				options={options}
			/>
		</div>
	);
};

export default ColumnChart;
